import React from 'react'
import Popover from 'components/Popover/Popover'
import { MathComponent } from 'mathjax-react'

const textAsReactComponent = text => {
  let newText = text
  const miliseconds = new Date().getMilliseconds()
  let htmlId = `text-as-component-${miliseconds}`
  let cssClass = 'text-as-component'
  if (newText.includes('<source>')) {
    newText = newText.replace('<source>', '<span>')
    newText = newText.replace('</source>', '</span>')
  }

  if (newText.includes('data-toggle="popover"')) {
    newText = newText.replace('<strong><a class="popup-text"', '<a class="popup-text"')
    newText = newText.replace('</a></strong>', '</a>')
    htmlId = `paragraph-with-popover-${miliseconds}`
    cssClass = 'paragraph-with-popover'
  }

  const doc = new DOMParser().parseFromString(
    `<div id="${htmlId}" class="${cssClass}">${newText}</div>`,
    'text/html',
  )

  return createElement(doc.getElementById(htmlId), '_0')
}

const createElement = (element, key) => {
  const attributes = {}
  const children = []
  for (let i = 0; i < element.attributes.length; i++) {
    const attr = element.attributes[i]
    if (attr.name === 'class') {
      attributes.className = attr.value
    } else {
      attributes[attr.name] = attr.value
    }
  }

  attributes.key = key

  for (let i = 0; i < element.childNodes.length; i++) {
    if (element.childNodes[i].nodeName === '#text') {
      children.push(element.childNodes[i].nodeValue)
    } else {
      children.push(createElement(element.childNodes[i], i + key))
    }
  }

  if (attributes.className && attributes.className.includes('popup-text')) {
    return React.createElement(Popover, { content: attributes['data-content'], key }, children)
  }

  if (element.tagName.toLowerCase() === 'p') {
    return React.createElement('div', { className: 'p-style', key: attributes.key }, children)
  }

  if (element.tagName.toLowerCase() === 'math') {
    const mathAttributes = {
      mathml: `<math xmlns="http://www.w3.org/1998/Math/MathML">${element.innerHTML}</math>`,
      key: attributes.key,
      display: false,
    }
    return React.createElement(MathComponent, mathAttributes, null)
  }

  if (['br', 'hr', 'img'].includes(element.tagName.toLowerCase())) {
    return React.createElement(element.tagName.toLowerCase(), attributes, null)
  }

  return React.createElement(element.tagName.toLowerCase(), attributes, children)
}

export default textAsReactComponent
